import { accordion } from '../../js/modules/accordion.js';
import { prepareDots } from '../../js/modules/pageNavigation.js';

(function () {
    let form = document.querySelector('[data-faq]');

    let ajaxUrl = php_vars.ajaxUrl;

    function filterList() {

        if (form) {
            let container = document.querySelector('#object-list');
            let filterObject = getValues();
            let loader = document.querySelector('.loader');

            jQuery.ajax({
                type: 'post',
                url: ajaxUrl,
                data: filterObject,
                beforeSend: function () {
                    container.innerHTML = '';
                    loader.classList.add('visible');
                },
                error: function (error) {
                    console.log(error);
                },
                success: function (response) {
                    loader.classList.remove('visible');
                    container.innerHTML = response;
                    setTimeout(function() {
                        accordion();
                        prepareDots();
                        assignAccordionClick();
                    }, 10);
                }
            });
        }
    }


    function getValues() {
        let obj = {};
        let search = form.querySelector('[name="search"]').value;

        obj.action = 'filterFaqList';
        obj.search = search;

        return obj;
    }

    function initInputHandlers() {
        if( form ) {
            let button = form.querySelector('[type="submit"]');

            if( button ) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    filterList();
                });
            }
        }
    }
    function assignAccordionClick() {
        let accordionElems = document.querySelectorAll('.accordion__title');

        if( accordionElems.length ) {
            accordionElems.forEach(function(item) {
                item.addEventListener('click', function() {
                    setTimeout(function() {
                        assignDotActiveState();
                    }, 800);
                })
            });
        }
    }


    window.addEventListener('load', function () {

        filterList();
        initInputHandlers();


    });
}())


//////////////////
// WEBPACK FOOTER
// ./js/modules/faq.js
// module id = 18
// module chunks = 0